import React, { useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import HelpIcon from '@material-ui/icons/Help';
import SvgIcon from '@material-ui/core/SvgIcon';
import NumberFormat from 'react-number-format';
import { Row, Col, Container, Modal } from "react-bootstrap";
import { Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

export default function Compare(props) {
    const tableThStyle = {
        fontWeight: '600',
        fontSize: '15px',
        paddingBottom: '5px',
        paddingTop: '5px'
    }

    const tableTdStyle = {
        font: 'var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-12)/var(--unnamed-line-spacing-16) var(--unnamed-font-family-museo-sans)',
        color: '#555555',
        borderLeft: '1px solid rgba(224, 224, 224, 1)'
        }

    const ButtonStyle = {
        paddingTop: '7px',
        paddingBottom: '7px',
        border: 'none',
        backgroundColor: "#ffffff"
    }

    const fontWeightClass = {
        fontWeight: '300',
        color: '#555555'
    }
   
    const quotes = props.quoter && props.quoter.selectedQuotes ? props.quoter.selectedQuotes : [];
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({});

    let mgmaIdx = quotes.findIndex((quote) => quote.product.includes("Market Advantage"));

    if (mgmaIdx !== -1) {
      quotes.push(quotes[mgmaIdx]);
      quotes.splice(mgmaIdx, 1);
      mgmaIdx = quotes.length - 1;
    }

    const setHintText = (name) => {
        let modalDeails = {};
        switch (name) {
            case 'Rating':
                modalDeails.title = name
                modalDeails.text = 'This indicates the financial strength of the insurance carrier.';
                break;
            case 'Total Premium':
                modalDeails.title = name
                modalDeails.text = 'Amount Paid over Premium Mode';
                break;
            case 'Elimination Periods':
                modalDeails.title = name
                modalDeails.text = 'Long–term care policies have an elimination period, which is the number of days the insured must need nursing home care or home health care before the policy pays benefits.';
                break;
            case 'Total LTC Benefit on Day 1 of Eligibility':
                modalDeails.title = name
                modalDeails.text = 'Total Long-Term Care (LTC) Benefit is the total maximum amount of LTC benefits available to the insured from the policy, on day 1 after the elimination period has been satisfied. The value includes any selected inflation options.';
                break;
            case 'Total Monthly LTC Benefit on Day 1 of Eligibility':
                modalDeails.title = name
                modalDeails.text = 'Maximum Monthly Long-Term Care (LTC) Benefit is the amount that the insured will be paid every month if they choose to receive the full LTC benefit amount, on day 1 after the elimination period has been satisfied. The value includes any selected inflation options.';
                break;
            case 'Death Benefit on Day 1 of Eligibility':
                modalDeails.title = name
                modalDeails.text = "This is the life insurance policy proceeds payable to the beneficiary upon the insured's death, on day 1 after the elimination period has been satisfied. The value includes any selected inflation options.";
                break;
            case 'Guaranteed Minimum Death Benefit':
                modalDeails.title = name
                modalDeails.text = "As long as the policy stays in force, the carrier guarantees they will pay the insured's beneficiaries a death benefit, even if the death benefit amount quoted is exhausted by the payment of long-term care (LTC) benefits. This death benefit may be lower if loans or partial surrenders are taken.";
                break;
            case 'Total LTC Benefit Age 80':
                modalDeails.title = name
                modalDeails.text = 'The amount of long-term care benefits at the clients age of 80.';
                break;
            case 'Benefit Duration Periods':
                modalDeails.title = name
                modalDeails.text = 'The Benefit Duration Period represents the total period of time long-term care (LTC) benefits may be paid under the policy if the maximum LTC benefit is taken continuously.';
                break;
            case 'Inflation Benefit Options':
                modalDeails.title = name
                modalDeails.text = 'This is a feature in the long-term care (LTC) policy that allows value of benefits to increase by a pre-defined percentage at specific time periods. Insurance inflation protection is designed to allow policyholders to make sure that the benefits they receive can keep up with the rate of inflation.';
                break;
            case 'Premium Mode':
                modalDeails.title = name
                modalDeails.text = 'Premium mode indicates the payment schedule that the insured selects to pay the premium required for their insured benefits.';
                break;
            case 'Return of Premium':
                modalDeails.title = name
                modalDeails.text = "Return of Premium will give the insured's beneficiary a death benefit equal to the sum of your long-term care (LTC) premiums paid over time.";
                break;
            default:
                modalDeails.title = ""
                modalDeails.text = "";
                break;
        }
        setModalData(modalDeails);
        setShowModal(true)
    } 

    return (

        <Container>
         <Row className='px-5'>
            <TableContainer>
                <Table aria-label="State License Disclosure">
                    <TableBody>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle}><img className="carrier-logo-lg" key={i} src={index.logoUrl} alt={`${index.product} Logo`} /></TableCell>
                                )
                            }

                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' role='button' onClick={() => setHintText('Rating')} />
                                Ratings
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>{index.rating}</TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' />
                                Product
                            </TableCell>

                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>{index.product}</TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' role='button' onClick={() => setHintText('Total Premium')} />
                                Total Premium
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>
                                        $
                                        <NumberFormat
                                            className="quote-amount-dollars-small"
                                            value={index.premium}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            decimalScale={0}
                                            fixedDecimalScale={true}
                                        /></TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' role='button' onClick={() => setHintText('Elimination Periods')} />
                                Elimination Period
                                <p className='mt-4 mb-0' style={fontWeightClass}>TOTAL ON DAY 1 OF ELIGIBILITY</p>

                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>{index.eliminationPeriod}</TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' role='button' onClick={() => setHintText('Total LTC Benefit on Day 1 of Eligibility')} />
                                LTC Benefit
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>
                                        $
                                        <NumberFormat
                                            className="quote-amount-dollars-small"
                                            value={index.initialTotalLTCBenefit}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            decimalScale={0}
                                            fixedDecimalScale={true}
                                        />
                                    </TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' role='button' onClick={() => setHintText('Total Monthly LTC Benefit on Day 1 of Eligibility')} />
                                Monthly LTC Benefit
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>
                                        $
                                        <NumberFormat
                                            className="quote-amount-dollars-small"
                                            value={index.initialMonthlyLTCBenefit}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            decimalScale={0}
                                            fixedDecimalScale={true}
                                        /></TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' role='button' onClick={() => setHintText('Death Benefit on Day 1 of Eligibility')} />
                                Death Benefit
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>
                                        $
                                        <NumberFormat
                                            className="quote-amount-dollars-small"
                                            value={index.initialDeathBenefit}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            decimalScale={0}
                                            fixedDecimalScale={true}
                                        /></TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' role='button' onClick={() => setHintText('Guaranteed Minimum Death Benefit')} />
                                Guaranteed Min. Death Benefit
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                  <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ? 'color-class' : ''}`}>{index.guaranteedMinDeathBenefit}</TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' role='button' onClick={() => setHintText('Total LTC Benefit Age 80')} />
                                Total LTC Benefit Age 80
                                <p className='mt-4 mb-0' style={fontWeightClass}>AVAILABLE OPTIONS</p>
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>
                                        $
                                        <NumberFormat
                                            className="quote-amount-dollars-small"
                                            value={index.endOfYearCoverage}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            decimalScale={0}
                                            fixedDecimalScale={true}
                                        /></TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' />
                                Max. Death Benefit
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>
                                        $
                                        <NumberFormat
                                            className="quote-amount-dollars-small"
                                            value={index.maxDeathBenefit}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            decimalScale={0}
                                            fixedDecimalScale={true}
                                        /></TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' role='button' onClick={() => setHintText('Benefit Duration Periods')} />
                                Benefit Duration Periods
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>
                                        {index.benefitDurationPeriod}</TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' role='button' onClick={() => setHintText('Inflation Benefit Options')} />
                                Inflation Benefit Options
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>{index.inflationBenefitOption}</TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' role='button' onClick={() => setHintText('Premium Mode')} />
                                Premium Mode
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>{index.premiumModeOption}</TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                <SvgIcon component={HelpIcon} color='primary' className='mr-2' role='button' onClick={() => setHintText('Return of Premium')} />
                                Return of Premium
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>{index.returnOfPremium}</TableCell>
                                )
                            }
                        </TableRow>
                        <TableRow className='header-class'>
                            <TableCell style={tableThStyle} component="th" scope="row">
                                Benefit Payment
                            </TableCell>
                            {
                                quotes.map((index, i) =>
                                    <TableCell style={tableTdStyle} key={i} scope="row" className={`${i===mgmaIdx ?'color-class':''}`}>{index.benefitPayment}</TableCell>
                                )
                            }
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <Row className="quoter w-100 mt-5">
                <Col sm={3} className='px-0'>
                    <Button variant="outlined" style={ButtonStyle} className='float-left ml-3 mt-2' onClick={() => props.onBack()} fullWidth color="primary" >
                    SIMPLIFIED VIEW
                    </Button>
                </Col>
                <Col sm={{ span: 5, offset: 4 }} className='px-0'>
                    <Button variant="contained" className='float-right mt-2 mr-n3' color="primary" onClick={() => props.onNext()} disabled={props.basicInfo.pages.retrieveAccount.clientType === 'Prospect' || (quotes && quotes.lenght === 0)}>
                        REQUEST ILLUSTRATION
                    </Button>
                </Col>
            </Row>
         </Row>
         <Modal show={showModal} onHide={() => setShowModal(false)} animation={false} size='lg'>
            <Modal.Header className='pb-0'>
                <Modal.Title>{modalData.title}</Modal.Title>
                <IconButton className="close-button" aria-label="close" onClick={() => setShowModal(false)}>
                    <CloseIcon />
                </IconButton>
            </Modal.Header>
            <Modal.Body>
                {modalData.text}
            </Modal.Body>
        </Modal>
        </Container>
    )
}
Compare.DefaultFormState = () => {
    return {
        selectedQuotes : [],
    }
};


// WEBPACK FOOTER //
// ./src/components/Product/ABLTC/RequestIllustration/Steps/Compare.js